import { useCallback } from 'react';
import { useLoader } from '@Comments/services/openapiClient';
import { AppState } from '@Comments/models/AppState';
import { useAppDispatcher, useAppContext } from '@Comments/context/AppContext';

export const useLoaderActions = () => {
  const { sortOrder, comments, nextToken } = useAppContext();
  const dispatch = useAppDispatcher();
  const loader = useLoader();

  return {
    loadComments: useCallback(
      async (limit: number, appState: AppState) => {
        try {
          dispatch({ type: 'update-app-state', data: appState });
          const result = await loader.loadCommentsByThread(
            limit,
            nextToken,
            sortOrder,
          );
          dispatch({
            type: 'update-comments',
            data: {
              comments: comments.concat(result.entries),
              nextToken: result.nextToken,
              limit: limit,
              hasMoreComments: result.hasMoreResults,
              appState: 'ready',
            },
          });
        } catch (error) {
          dispatch({ type: 'update-app-state', data: 'comments-error' });
          // eslint-disable-next-line no-console
          console.error(error);
        }
      },
      [comments, dispatch, loader, nextToken, sortOrder],
    ),
  };
};
